const PlummeAccountingExportTools = (() => {
  const number = (value) => Number(value) || 0;
  const csvCell = (value) => {
    const text = String(value ?? '');
    return /[";\n\r]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
  };
  const downloadCsv = (filename, columns, rows) => {
    const csv = [
      columns.map((column) => csvCell(column.header)).join(';'),
      ...rows.map((row) => columns.map((column) => csvCell(column.value(row))).join(';')),
    ].join('\r\n');
    const url = URL.createObjectURL(new Blob([`\uFEFF${csv}`], { type: 'text/csv;charset=utf-8' }));
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = filename;
    document.body.appendChild(anchor);
    anchor.click();
    anchor.remove();
    URL.revokeObjectURL(url);
  };
  const invoiceLineNet = (line = {}) => {
    const base = number(line.quantity || 1) * number(line.unitPrice ?? line.price);
    const discount = number(line.discountValue ?? line.discount);
    if (!discount) return base;
    return line.discountType === 'amount'
      ? base - Math.sign(base) * Math.min(Math.abs(base), discount)
      : base * (1 - Math.min(100, discount) / 100);
  };
  const buildInvoiceExportRows = (invoices = [], payments = []) => (invoices || []).flatMap((invoice) => {
    const lines = Array.isArray(invoice.lines) && invoice.lines.length ? invoice.lines : [{}];
    const invoicePayments = (payments || []).filter((payment) => payment.documentType === 'invoice' && payment.documentId === invoice.id && payment.status !== 'reversed');
    const paidAmount = invoicePayments.reduce((sum, payment) => sum + number(payment.amount), 0);
    const rawGrossTotal = lines.reduce((sum, line) => {
      const net = invoiceLineNet(line);
      const treatment = line.vatTreatment || (number(line.vatRate) === 0 ? 'zeroRated' : 'standard');
      return sum + net + (treatment === 'standard' ? net * number(line.vatRate) / 100 : 0);
    }, 0);
    const factor = invoice.kind === 'credit' && rawGrossTotal > 0 ? -1 : 1;
    const amounts = invoice.accountingRoundingVersion === 'NO-VAT-BUCKET-1' ? invoice.accountingAmounts : null;
    const grossTotal = (amounts ? amounts.total : rawGrossTotal) * factor;
    return lines.map((line, index) => {
      const net = (amounts ? amounts.lines[index].net : invoiceLineNet(line)) * factor;
      const vatRate = number(line.vatRate);
      const vatTreatment = line.vatTreatment || (vatRate === 0 ? 'zeroRated' : 'standard');
      const vat = amounts ? amounts.lines[index].vat * factor : vatTreatment === 'standard' ? net * vatRate / 100 : 0;
      return {
        id: invoice.id || '', kind: invoice.kind || 'invoice', invoiceNumber: invoice.invoiceNumber || '', date: invoice.date || '', dueDate: invoice.dueDate || '',
        customerNumber: invoice.customer?.nr || invoice.customer?.customerNumber || '', customerName: invoice.customer?.name || '', organizationNumber: invoice.customer?.organizationNumber || invoice.customer?.org || '',
        email: invoice.customer?.email || '', currency: invoice.currency || 'NOK', status: invoice.status || '', paymentStatus: invoice.paymentStatus || '', paidAmount, outstandingAmount: invoice.kind === 'credit' ? -Math.max(0, Math.abs(grossTotal) - paidAmount) : Math.max(0, grossTotal - paidAmount),
        paymentDates: invoicePayments.map((payment) => payment.date).filter(Boolean).join(', '), ourReference: invoice.ourReference || '', customerReference: invoice.customerReference || invoice.theirReference || '', comment: invoice.comment || '',
        lineNumber: index + 1, itemNumber: line.itemNumber || line.productNumber || line.nr || '', description: line.description || line.name || '', unit: line.unit || '', quantity: number(line.quantity || 1), unitPrice: number(line.unitPrice ?? line.price),
        discount: number(line.discountValue ?? line.discount), discountType: line.discountType || '', vatRate, vatTreatment, accountCode: line.accountCode || line.salesAccountCode || '', netAmount: net, vatAmount: vat, grossAmount: net + vat,
        attachments: (invoice.attachments || []).map((attachment) => attachment.name).filter(Boolean).join(', '),
      };
    });
  });
  const columns = [
    ['ID', 'id'], ['Type', 'kind'], ['Fakturanr.', 'invoiceNumber'], ['Dato', 'date'], ['Forfallsdato', 'dueDate'], ['Kundenr.', 'customerNumber'], ['Kunde', 'customerName'], ['Organisasjonsnummer', 'organizationNumber'], ['E-post', 'email'], ['Valuta', 'currency'], ['Status', 'status'], ['Betalingsstatus', 'paymentStatus'], ['Betalt', 'paidAmount'], ['Utestående', 'outstandingAmount'], ['Betalingsdatoer', 'paymentDates'], ['Vår referanse', 'ourReference'], ['Deres referanse', 'customerReference'], ['Kommentar', 'comment'], ['Linje', 'lineNumber'], ['Varenr.', 'itemNumber'], ['Beskrivelse', 'description'], ['Enhet', 'unit'], ['Antall', 'quantity'], ['Enhetspris', 'unitPrice'], ['Rabatt', 'discount'], ['Rabattype', 'discountType'], ['MVA-sats', 'vatRate'], ['MVA-behandling', 'vatTreatment'], ['Konto', 'accountCode'], ['Netto', 'netAmount'], ['MVA', 'vatAmount'], ['Brutto', 'grossAmount'], ['Vedlegg', 'attachments'],
  ].map(([header, key]) => ({ header, value: (row) => row[key] }));
  const exportInvoices = (invoices = [], payments = []) => {
    const rows = buildInvoiceExportRows(invoices, payments);
    downloadCsv('plumme-fakturaer.csv', columns, rows);
    return rows.length;
  };
  return { buildInvoiceExportRows, exportInvoices };
})();

Object.assign(globalThis, { PlummeAccountingExportTools });
